export const PANAS_ITEMS: { word: string; type: 'positive' | 'negative' }[] = [
  { word: 'Interested',   type: 'positive' },
  { word: 'Distressed',   type: 'negative' },
  { word: 'Excited',      type: 'positive' },
  { word: 'Upset',        type: 'negative' },
  { word: 'Strong',       type: 'positive' },
  { word: 'Guilty',       type: 'negative' },
  { word: 'Scared',       type: 'negative' },
  { word: 'Hostile',      type: 'negative' },
  { word: 'Enthusiastic', type: 'positive' },
  { word: 'Proud',        type: 'positive' },
  { word: 'Irritable',    type: 'negative' },
  { word: 'Alert',        type: 'positive' },
  { word: 'Ashamed',      type: 'negative' },
  { word: 'Inspired',     type: 'positive' },
  { word: 'Nervous',      type: 'negative' },
  { word: 'Determined',   type: 'positive' },
  { word: 'Attentive',    type: 'positive' },
  { word: 'Jittery',      type: 'negative' },
  { word: 'Active',       type: 'positive' },
  { word: 'Afraid',       type: 'negative' },
]

export const SCALE_LABELS: Record<number, string> = {
  1: 'Very slightly or not at all',
  2: 'A little',
  3: 'Moderately',
  4: 'Quite a bit',
  5: 'Extremely',
}

export const SCORE_WORDS: Record<number, string> = {
  1: 'ONE', 2: 'TWO', 3: 'THREE', 4: 'FOUR', 5: 'FIVE',
}

export function calculatePanasPercent(all: Record<number, number>): number {
  let pa = 0
  let na = 0
  PANAS_ITEMS.forEach((item, i) => {
    const v = all[i] ?? 1
    if (item.type === 'positive') pa += v
    else na += v
  })
  return Math.round(((pa - na) + 40) / 80 * 100)
}

export function panasScoreFromPartialAnswers(all: Record<number, number>): number | null {
  const answered = Object.keys(all)
  if (answered.length === 0) return null

  let pa = 0
  let na = 0
  let nPos = 0
  let nNeg = 0

  for (const key of answered) {
    const i = Number(key)
    const v = all[i]
    if (PANAS_ITEMS[i].type === 'positive') {
      pa += v
      nPos += 1
    } else {
      na += v
      nNeg += 1
    }
  }

  const diff = pa - na
  const minDiff = nPos - 5 * nNeg
  const range = 4 * (nPos + nNeg)
  return Math.round(((diff - minDiff) / range) * 100)
}
